import { useCallback, useRef, useState } from "react";

/**
 * Shared gate for ImagePickerModal — one instance per page/screen.
 *
 * openImagePicker({ onPickFile, onPickLibrary })
 */
export function useImagePickerModal() {
  const [isOpen, setIsOpen] = useState(false);
  const handlersRef = useRef({});

  const openImagePicker = useCallback((handlers = {}) => {
    handlersRef.current = handlers;
    setIsOpen(true);
  }, []);

  const closeImagePicker = useCallback(() => {
    setIsOpen(false);
    handlersRef.current = {};
  }, []);

  const onPickFile = useCallback((file) => {
    const { onPickFile: handler } = handlersRef.current;
    setIsOpen(false);
    handlersRef.current = {};
    handler?.(file);
  }, []);

  const onPickLibrary = useCallback((item) => {
    const { onPickLibrary: handler } = handlersRef.current;
    setIsOpen(false);
    handlersRef.current = {};
    handler?.(item);
  }, []);

  return {
    openImagePicker,
    closeImagePicker,
    imagePickerProps: {
      isOpen,
      onClose: closeImagePicker,
      onPickFile,
      onPickLibrary,
    },
  };
}
